import { render, staticRenderFns } from "./SIPStats.vue?vue&type=template&id=19c81e72&scoped=true&"
import script from "./SIPStats.vue?vue&type=script&lang=js&"
export * from "./SIPStats.vue?vue&type=script&lang=js&"
import style0 from "./SIPStats.vue?vue&type=style&index=0&id=19c81e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c81e72",
  null
  
)

export default component.exports